import OperatorScreen from './components/OperatorScreen'

export default {
  path: '/operadora',
  name: 'Operator',
  component: OperatorScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Operator/index.js